<template>
  <div class="sect phone_product">
    <div class="m_sec_ttl"><h4>어떤 휴대폰을 찾고 계시나요?</h4></div>
    <div class="sec_cont">
      <div class="input_txt input_srch">
        <input
          type="search"
          placeholder="휴대폰 검색"
          v-model.trim="keyword"
          @keypress.enter="fnSearch"
        />
        <button class="btn_srch" @click.stop="fnSearch"></button>
      </div>
      <div class="pro_filter">
        <div class="filter_inner">
          <div class="btn_refresh_cover">
            <button class="btn_refresh" @click="resetFilter">
              <img
                src="@/assets/front/images/v2/arrows/ar_refresh.svg"
                alt="새로고침"
              />
            </button>
          </div>
          <div class="btn_select_cover">
            <button class="btn_select" @click="openFilter('tab_1')">
              제조사{{
                filter.manufacturer[0] === 'ALL'
                  ? ''
                  : `(${filter.manufacturer.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_2')">
              RAM{{ filter.ram[0] === 'ALL' ? '' : `(${filter.ram.length})` }}
            </button>
            <button class="btn_select" @click="openFilter('tab_3')">
              내장메모리{{
                filter.inMemory[0] === 'ALL'
                  ? ''
                  : `(${filter.inMemory.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_4')">
              외장메모리{{
                filter.exMemory[0] === 'ALL'
                  ? ''
                  : `(${filter.exMemory.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_5')">
              화면크기{{
                filter.screen[0] === 'ALL' ? '' : `(${filter.screen.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_6')">
              베터리{{
                filter.battery[0] === 'ALL' ? '' : `(${filter.battery.length})`
              }}
            </button>
          </div>
        </div>
      </div>
      <div class="list_order">
        <p>총 {{ total }}개</p>
        <button class="btn_order" @click="openSortModal">
          {{ selectedSort.label }}
        </button>
      </div>
      <div class="phone_pro_list">
        <ul class="phone_pro_list_ul" v-if="list.length > 0">
          <MobileProduct
            v-for="(item, index) in list"
            :key="index"
            :item="item"
            @view="goItemView"
            @goMobile="goMobile"
          />
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>
                  필터 검색 결과가 없습니다.<br />다른 옵션을 선택해 주세요!
                </div>
              </div>
            </div>
          </div>
        </ul>
        <div class="more_btn">
          <button @click="viewMore" v-if="total > 5 && list.length !== total">
            <span>더보기</span>
            <img src="@/assets/front/images/v2/arrows/ar_hash_down.svg" />
          </button>
        </div>
      </div>
    </div>
    <SortModal
      :value="selectedSort"
      :show="isSortModal"
      @close="cloasSortModal"
    />
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'alert',
        msg: `최초 견적요청일로부터 일주일이 지나야만 재요청이 가능합니다.`,
      }"
      @close="popupClose"
    />
  </div>
</template>

<script>
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import MobileProduct from '@/front/customer/views/home/components/MobileProduct.vue';
import SortModal from '../modal/MobileProductSortModal';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  name: 'MobileProducts',
  description: '사용자 메인 - 어떤 휴대폰을 찾고 계시나요?',
  props: {
    list: Array,
    total: Number,
    filter: Object,
    params: Object,
    isMobileCreate: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MobileProduct,
    SortModal,
    DesignPopup2,
  },
  data(props) {
    return {
      wirelessCharge: props.params.wirelessCharge,
      samsungPay: props.params.samsungPay,
      applePay: props.params.applePay,
      waterproof: props.params.waterproof,
      film: props.params.film,
      isSortModal: false,
      selectedSort: { label: '인기 순', value: 'POPULARITY' },
      isHashTag: ['N', 'N', 'N', 'N', 'N'],
      keyword: '',
      designPopup: false,
    };
  },
  methods: {
    ...mobileMapActions([mobileTypes.UPDATE_MOBILE_SEL_PRODUCT]),
    selectWireless() {
      this.wirelessCharge = this.wirelessCharge == 'ON' ? 'OFF' : 'ON';
      this.$emit('fetch', 'wirelessCharge', this.wirelessCharge);
    },
    selectSamsungPay() {
      this.samsungPay = this.samsungPay == 'ON' ? 'OFF' : 'ON';
      this.$emit('fetch', 'samsungPay', this.samsungPay);
    },
    selectApplePay() {
      this.applePay = this.applePay == 'ON' ? 'OFF' : 'ON';
      this.$emit('fetch', 'applePay', this.applePay);
    },
    selectWaterproof() {
      this.waterproof = this.waterproof == 'ON' ? 'OFF' : 'ON';
      this.$emit('fetch', 'waterproof', this.waterproof);
    },
    selectFilm() {
      this.film = this.film == 'ON' ? 'OFF' : 'ON';
      this.$emit('fetch', 'film', this.film);
    },
    openSortModal() {
      this.isSortModal = true;
    },
    cloasSortModal(val) {
      if (val) {
        this.selectedSort = val;
        this.$emit('fetch', 'orderType', val.value);
      }
      this.isSortModal = false;
    },
    viewMore() {
      this.$emit('more');
    },
    resetFilter() {
      this.selectedSort = { label: '인기 순', value: 'POPULARITY' };
      this.keyword = ''; // 검색어
      this.wirelessCharge = 'OFF';
      this.samsungPay = 'OFF';
      this.applePay = 'OFF';
      this.waterproof = 'OFF';
      this.film = 'OFF';
      this.$emit('reset');
    },
    openFilter(selTab) {
      this.$emit('filter', selTab);
    },
    goItemView(item) {
      this.$emit('view', item);
    },
    fnSearch() {
      // if (!this.keyword.trim()) return;
      this.$emit('searchKeyword', this.keyword.trim());
    },
    toggleHashTag(sel) {
      if (this.isHashTag[sel] === 'Y') {
        // 배열은 값을 바로 넣으면 바인딩이 안되므로 아래와 같이 처리 해야한다.
        // Vue.set() 혹은 this.$set() 을 통해 배열이나 객체의 값이 갱신되었다 라고 요청하는 것이며
        // Vue.delete() 혹은 this.$delete() 를 통해 객체의 속성이 제거되었다 라고 요청하는 것이다.
        // this.$set(arr, index, value), this.$set(obj, key, value), this.$delete(obj, key)
        this.$set(this.isHashTag, sel, 'N');
      } else {
        this.$set(this.isHashTag, sel, 'Y');
      }
    },
    goMobile(item) {
      if (this.isMobileCreate) {
        this.$emit('setVisitPage');
        localStorage.setItem('myMobileModelName', item.modelName);
        // 상품 견적 카운트 증가
        this.upSelProductCnt(item);

        this.$router.push({
          name: 'Mobile.Create',
          query: {
            mode: 'MY_MOBILE',
          },
        });
      } else {
        this.designPopup = true;
      }
    },
    upSelProductCnt(item) {
      const params = {
        modelId: item.modelId,
      };
      console.log('params :: {}', params);
      this[mobileTypes.UPDATE_MOBILE_SEL_PRODUCT](params);
    },
    popupClose() {
      this.designPopup = false;
    },
  },
};
</script>
